import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import { Box, Button, Tooltip, Typography, TextField, Paper, Autocomplete, Table, TableHead, TableBody, TableRow, TableCell, MenuItem, FormControl, InputLabel, Select, IconButton, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard, DeletePopup } from '../../../../../Components/Common Components/CommonComponents';
import CommonValidation from '../../../../../Components/CommonFunctions/CommonValidation';
import { withTranslation } from 'react-i18next'
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import { Colors } from '../../../../../Styles/Colors'
import { CheckAccessFunc, debounce } from '../../../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import { DateTime } from "luxon";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Loader from '../../../../../Components/Loader';
import AddIcon from '@mui/icons-material/Add';
const hourList = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
const minuteList = ["00", "15", "30", "45"];
const meridianList = ["AM", "PM"];

const convertToTimeString = (hour, minute, meridian) => {
    let h = parseInt(hour, 10);

    // Convert to 24-hour format
    if (meridian === 'pm' && h !== 12) h += 12;
    if (meridian === 'am' && h === 12) h = 0;

    const HH = String(h).padStart(2, '0');
    const MM = String(minute).padStart(2, '0');
    const SS = "00";

    return `${HH}:${MM}:${SS}`;
};

const processTimeData = (data) => {
    const result = {};

    // Loop through all keys in the data
    for (const [key, value] of Object.entries(data)) {
        // Only process time-related data, which are in "hh:mm AM/PM" format
        const timeRegex = /^\d{2}:\d{2} (AM|PM)$/;

        if (timeRegex.test(key) && value !== "-") {
            const [timePart, period] = key.split(" ");
            const [hour, minute] = timePart.split(":");
            const meridian = period.toLowerCase();

            // Convert time to 24-hour format
            const time24 = convertToTimeString(hour, minute, meridian);

            // Only include valid numeric values
            result[time24] = parseFloat(value);
        }
    }

    return result;
}

const GlucoseLog = (props) => {
    const UserData = JSON.parse(localGetItem("loggedInUserInfo") || "{}");
    const [state, setState] = useState({
        // patient details
        attender_name: "",
        attender_mobile: "",
        doctor_name: "",
        doctor_id: "",
        patientData: {},
        withOutAppointment: {},
        clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
        myUser: JSON.parse(localGetItem("loggedInUserInfo")),
        // state value
        selectedDate: new Date(),
        drug_name: null,
        drugList: [],
        hours: null,
        minutes: null,
        meridian: null,
        glucose_value: "",
        glucoseData: [],
        headerData: [],
        deletePopup: false,
        selectedId: null,
        // edit state 
        isEditClked: false,
        editIndex: null,
        editData: {},
        saveClked: false,
        addClked: false,
        // filter state
        high_value: "",
        low_value: "",
        // message
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        isLoader: false,
        page: 0,
        pageSize: 10,
        unitData: [],
        instruction: "",
        index: "",
        confirmPopup: false,
        NurseList: [],
        nurseName: null,
    })
    const [isLoading, setIsLoading] = useState({})
    const [unitType, setUnitType] = useState('')
    const [drugFields, setDrugFields] = useState([
        { drug_name: "", drugList: [], unitType: "", unitValue: "" }
    ]);
    const plusHandle = () => {
        setDrugFields(prev => [
            ...prev,
            { drug_name: "", drugList: [], unitType: "", unitValue: "" }
        ]);
    };
    const filterUnit = state?.unitData?.filter((val) =>
        val?.unit?.toLowerCase().includes(unitType?.toLowerCase() || "")
    );

    const getDrugSuggestionApi = useRef();

    useEffect(() => {
        const patientDatas = JSON.parse(getCachevalue("IppatientData") || "{}");
        const appointmentDetail = JSON.parse(getCachevalue("withoutAppointment") || "{}");
        const samePatient = appointmentDetail?.patient_id === patientDatas?.patient_id;
        getNurseList();
        setState((prevState) => ({
            ...prevState,
            patientData: patientDatas,
            withOutAppointment: samePatient ? appointmentDetail : {}
        }));
    }, [])

    useEffect(() => {
        if (state?.patientData?.patient_id || state?.withOutAppointment?.patient_id) {
            getPatientData();
            getGlucoseData();
            getUnitList()
        }
    }, [state?.patientData?.patient_id, state?.withOutAppointment?.patient_id])

    useEffect(() => {
        getDrugSuggestionApi.current = debounce((value, index) => {
            getDrugData(value, index);
        }, 500);
    }, []);
    // This useEffect will trigger when both NurseList and patient data are available
    useEffect(() => {
        if (state.NurseList.length > 0 && (state.patientData?.patient_id || state.withOutAppointment?.patient_id)) {
            getGlucoseData();
        }
    }, [state.NurseList, state.patientData?.patient_id, state.withOutAppointment?.patient_id])

    const disableBtn = useMemo(() => {
        return state.isLoader ? true :
            props.is_From_IpNotes ? false : CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Glucose Log", "SubTab")?.editAccess ?
                state.withOutAppointment?.is_ip : true
    }, [state.isLoader, props.is_From_IpNotes, state.withOutAppointment?.is_ip])
    const getUnitList = () => {
        try {
            RestAPIService.getAll(Serviceurls.LAB_PRODUCT_UNIT)
                .then((response) => {
                    if (response.data.status === "success") {
                        setState(prev => ({
                            ...prev,
                            unitData: response.data.data
                        }));

                    }
                }).catch((error) => {
                    console.log(error, "error")
                })
        } catch (error) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: error.message
            })
        }
    }

    const getGlucoseData = useCallback(() => {
        let isMounted = true;
        try {
            LoaderFunction(true);

            const admission_id =
                state.patientData?.id || state.withOutAppointment?.ip_admission_id;

            let url = `${Serviceurls.IP_DOC_GLUCOSE_GET}?ip_admission_id=${admission_id}`;
            if (props.is_From_IpNotes && state.clinic_id) {
                url = `${url}&clinic_id=${state.clinic_id}`;
            }

            RestAPIService.getAll(url)
                .then((response) => {
                    if (!isMounted) return;

                    if (response?.data?.status === "success") {
                        const Datas = response?.data?.data || [];

                        if (Datas.length > 0) {
                            const allDrugNames = [
                                ...new Set(
                                    Datas?.flatMap(item =>
                                        Array?.isArray(item.drugs)
                                            ? item.drugs.map(d => d.drug_name).filter(Boolean)
                                            : []
                                    )
                                ),
                            ];

                            const normalizedData = Datas?.map((item) => {
                                let normalizedGlucose = {};

                                if (
                                    item.glucose_value &&
                                    typeof item.glucose_value === "object"
                                ) {
                                    const outerKey = Object?.keys(item.glucose_value)[0];
                                    const outerValue = item?.glucose_value[outerKey];

                                    if (
                                        outerValue &&
                                        typeof outerValue === "object" &&
                                        !Array.isArray(outerValue)
                                    ) {
                                        const innerKey = Object.keys(outerValue)[0];
                                        normalizedGlucose = {
                                            [innerKey]: Number(outerValue[innerKey]) || 0,
                                        };
                                    } else {
                                        normalizedGlucose = {
                                            [outerKey]: Number(outerValue) || 0,
                                        };
                                    }
                                }
                                // Map nurse_profile_id to nurse name
                                let nurse_name = "-";
                                if (item.nurse_profile_id) {
                                    const foundNurse = state.NurseList?.find(
                                        nurse => nurse.staff_id === item.nurse_profile_id
                                    );
                                    nurse_name = foundNurse ? foundNurse.nurse : "-";
                                }
                                return {
                                    ...item,
                                    glucose_value: normalizedGlucose,
                                    nurse_name: nurse_name,
                                };
                            });

                            setState((prevState) => ({
                                ...prevState,
                                headerData: allDrugNames || [],
                                glucoseData: normalizedData || [],
                            }));
                        } else {
                            // Empty state handling
                            setState((prevState) => ({
                                ...prevState,
                                headerData: [],
                                glucoseData: [],
                            }));
                        }
                    }

                    LoaderFunction(false);
                })
                .catch((error) => {
                    if (!isMounted) return;
                    LoaderFunction(false);
                    errorMessage(
                        error?.response?.data?.message || error.message
                    );
                });

            return () => {
                isMounted = false;
            };
        } catch (error) {
            LoaderFunction(false);
            errorMessage(error.message);
        }
    }, [state?.patientData?.id, state?.withOutAppointment?.ip_admission_id, props.is_From_IpNotes, state?.clinic_id, state.NurseList]);


    const getDrugData = useCallback((search = '', index) => {

        try {
            setIsLoading((prev) => ({ ...prev, [index]: true }));
            RestAPIService.getAllTwo(Serviceurls.IP_DOC_GLUCOSE_DRUG_GET + `?search_key=${search}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        // if (state.drug_name) {
                        const Data = response.data.data?.map((item) => ({ ...item, displayTxt: `${item?.drug_name || ""} - ${item?.dosage_strength || ""} - ${item?.dosage_type || ""}` }))
                        onChangeHandle("drugList", Data || [])
                        // }
                        setIsLoading((prev) => ({ ...prev, [index]: false }));

                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                    setIsLoading((prev) => ({ ...prev, [index]: false }));
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }, [state.drug_name])

    const getPatientData = useCallback(() => {
        let admission_id = state.patientData?.id || state.withOutAppointment?.ip_admission_id;
        let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.FO_PATIENT_DETAILS : Serviceurls.FO_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
        if (props.is_From_IpNotes && state.clinic_id) {
            url = `${url}&clinic_id=${state.clinic_id}`
        }
        try {
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setState((prevState) => ({
                            ...prevState,
                            attender_name: response.data.data[0].attender_name,
                            attender_mobile: response.data.data[0].attender_mobile,
                            doctor_name: response.data.data[0].doctor_name,
                            doctor_id: response.data.data[0].doctor_id,
                        }))
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [state.patientData?.id, state.withOutAppointment?.ip_admission_id, state.clinic_id, props.is_From_IpNotes])

    const errorMessage = useCallback((message) => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: true,
            isErrorMsgText: message
        }))
    }, [])

    const successMessage = useCallback((message) => {
        setState((prevState) => ({
            ...prevState,
            successMsg: true,
            successMsgText: message
        }))
    }, [])

    const msgClose = useCallback(() => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }))
    }, [])

    const LoaderFunction = useCallback((key = false) => {
        setState((prevState) => ({
            ...prevState,
            isLoader: key
        }))
    }, [])

   const postGlucoseLog = useCallback(() => {
    let isMounted = true;
    try {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        const enteredDate = DateTime.fromJSDate(state.selectedDate).toFormat("dd-MM-yyyy");
        const enteredTime = convertToTimeString(state.hours, state.minutes, state.meridian);
        const glucoseValue = +(state?.glucose_value || 0);
        const instruction = state?.instruction?.trim() || "";
        const existingEntry = state?.glucoseData?.find(item =>
            item.entered_date === enteredDate &&
            item.entered_time === enteredTime
        );

        const drugNames = drugFields.map(d => d.drug_name?.toLowerCase().trim());
        const duplicateDrugs = new Set(drugNames).size !== drugNames.length;
        if (duplicateDrugs) {
            errorMessage("Same drug names are not allowed.");
            return;
        }

        if (existingEntry) {

            if (
                existingEntry &&
                Object.values(existingEntry?.glucose_value)
            ) {
                setState(prev => ({
                    ...prev,
                    confirmPopup: true,
                }));
                return;
            }
        }

     
        if (existingEntry && existingEntry.drugs?.length >= 3) {
            errorMessage("You can only add up to 3 drugs for the same date and time.");
            return;
        }
        if (drugFields.length > 3) {
            errorMessage("You can only add up to 3 drugs for the same date and time.");
            return;
        }
        if (!state.nurseName?.staff_id) {
            errorMessage("Please Select Nurse Name")
            return;
        } 

        createGlucoseLog();
    } catch (error) {
        onChangeHandle("addClked", false);
        errorMessage(error.message);
    }

    return () => { isMounted = false };
}, [
    state.patientData?.id,
    state.selectedDate,
    state.hours,
    state.minutes,
    state.meridian,
    state.glucose_value,
    state.clinic_id,
    drugFields,
    state.instruction,
    state.nurseName?.staff_id
]);

    const createGlucoseLog = () => {
        onChangeHandle("addClked", true);

        const data = {
            ip_admission_id: state.patientData?.id,
            entered_date: DateTime.fromJSDate(state.selectedDate).toFormat("yyyy-MM-dd"),
            entered_time: convertToTimeString(state.hours, state.minutes, state.meridian),
            glucose_value: +(state.glucose_value || 0),
            drugs: drugFields.map(field => ({
                drug_name: field.drug_name || "",
                unit_type: field.unitType || "",
                unit_value: Number(field.unitValue) || 0,
            })),
            instruction: state.instruction,
            nurse_profile_id: state.nurseName?.staff_id || null,
        };
        if (state.clinic_id) data["clinic_id"] = state.clinic_id;

        RestAPIService.create(data, Serviceurls.IP_DOC_GLUCOSE_GET)
            .then(response => {
                onChangeHandle("addClked", false);
                if (response.data.status === "success") {
                    successMessage(response.data.message);
                    onClearHandler();
                    getGlucoseData();
                } else {
                    errorMessage(response.data.message);
                }
            })
            .catch(error => {
                onChangeHandle("addClked", false);
                errorMessage(error?.response?.data?.message || error?.message);
            });
    };




    const updateGlucoseData = async () => {
        try {
            onChangeHandle("saveClked", true);
            const drugNames = drugFields.map(d => d.drug_name?.toLowerCase().trim());
            const duplicateDrugs = new Set(drugNames).size !== drugNames.length;
            if (duplicateDrugs) {
                errorMessage("Same drug names are not allowed.");
                return;
        }

            const data = {
                id: state?.editData?.id,
                entered_date: DateTime.fromJSDate(state.selectedDate).toFormat("yyyy-MM-dd"),
                entered_time: convertToTimeString(state.hours, state.minutes, state.meridian),
                glucose_value: +(state.glucose_value || 0),
                drugs: drugFields.map((field) => ({
                    drug_name: field.drug_name || "",
                    unit_type: field.unitType || "",
                    unit_value: Number(field.unitValue) || 0,
                })),
                instruction: state.instruction,
                nurse_profile_id: state.nurseName?.staff_id || null,
            };

            if (state.clinic_id) data["clinic_id"] = state.clinic_id;
            await RestAPIService.updateWithOutId(data, Serviceurls.IP_DOC_GLUCOSE_GET)
                .then((response) => {
                    onChangeHandle("saveClked", false);
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        onCancelHandler();
                        onClearHandler();
                        getGlucoseData();
                    } else {
                        errorMessage(response.data.message);
                    }
                })
                .catch((error) => {
                    onChangeHandle("saveClked", false);
                    errorMessage(error?.response?.data?.message || error?.message);
                });
        } catch (error) {
            onChangeHandle("saveClked", false);
            errorMessage(error.message);
        }
    };

    const getNurseList = useCallback(() => {
        return new Promise((resolve, reject) => {
            try {
                RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${state.clinic_id}`)
                    .then((response) => {
                        if (response.data.status === "success") {
                            setState((prevState) => ({
                                ...prevState,
                                NurseList: response.data.data
                            }), () => {
                                resolve(response.data.data);
                            })
                        }
                    }).catch((error) => {
                        errorMessage(error?.response?.data?.message || error.message);
                        reject(error);
                    })
            } catch (error) {
                errorMessage(error.message);
                reject(error);
            }
        });
    }, [state.clinic_id])


    const renderDatePicker = useCallback(() => {
        const stripTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const currentDate = stripTime(new Date());

        const admissionDate = state?.patientData?.admitted_date
            ? new Date(state.patientData.admitted_date)
            : state?.patientData?.admission_date
                ? new Date(state.patientData.admission_date)
                : currentDate;

        const dischargeDate = state.patientData?.discharge_date &&
            (new Date(state.patientData.discharge_date) <= currentDate)
            ? new Date(state.patientData.discharge_date)
            : currentDate;

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Date"
                    inputFormat={"dd-MM-yyyy"}
                    autoComplete="off"
                    value={state.selectedDate}
                    minDate={admissionDate}
                    maxDate={dischargeDate}
                    onChange={(newDate) => {
                        if (newDate) {
                            const selected = stripTime(new Date(newDate));
                            setState((prevState) => ({
                                ...prevState,
                                selectedDate: selected > currentDate ? currentDate : selected,
                            }));
                        } else {
                            setState((prevState) => ({
                                ...prevState,
                                selectedDate: null,
                            }));
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                        required
                            {...params}
                            size="small"
                            autoComplete="off"
                            variant="outlined"
                            sx={{ width: "15dvw" }}
                            inputProps={{
                                ...params.inputProps,
                                readOnly: true
                            }}
                            emed_tid="glucose_log_date_picker"
                        />
                    )}
                />
            </LocalizationProvider>
        );
    }, [
        state.selectedDate,
        state.patientData?.admitted_date,
        state?.patientData?.admission_date,
        state.patientData?.discharge_date
    ]);

    const renderDrugSearch = useCallback(() => {
        return (
            <Autocomplete
                size='small'
                clearIcon
                freeSolo
                autoSelect={false}
                options={state.drugList || []}
                getOptionLabel={option => typeof (option) === "string" ? option : option.displayTxt}
                value={state.drug_name || ''}
                onChange={(e, value) => {
                    setState((prevState) => ({
                        ...prevState,
                        drug_name: value?.displayTxt || '',
                    }))
                }}
                renderInput={(params) => <TextField {...params}
                    sx={{ width: "20dvw" }}
                    inputProps={{ ...params.inputProps, maxLength: 100 }}
                    onChange={(e) => {
                        const value = e.target.value;
                        setState(prev => ({
                            ...prev,
                            drug_name: value || "",
                            drugList: []
                        }));
                        if (value) {
                            getDrugSuggestionApi.current(value)
                        }
                    }}
                    label={"Select Drug"}
                    emed_tid="glucose_log_drug_autocomplete" />}
            />
        )
    }, [state.drugList, state.drug_name, getDrugSuggestionApi])
    const renderTextBox = useCallback((label, statekey, width = "15vw", fromRow = false) => {
        try {
            return (
                <TextField
                required
                    size='small'
                    sx={{ width: width }}
                    label={fromRow ? "" : label}
                    name={statekey}
                    value={fromRow ? state[statekey][label] || "" : state[statekey] || ""}
                    onChange={(e) => {
                        const { value } = e.target;


                        const isValid = CommonValidation.NumberWithDot(value) && +value <= 700;

                        if (value === '' || (isValid && +value !== 0)) {
                            if (fromRow) {
                                setState((prevState) => ({
                                    ...prevState,
                                    [statekey]: {
                                        ...prevState[statekey],
                                        [label]: value
                                    }
                                }));
                            } else {
                                onChangeHandle(statekey, value);
                            }
                        }
                    }}
                    InputProps={{
                        endAdornment:
                            statekey === "glucose_value" ? (
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                    mg/dl
                                </Typography>
                            ) : null,
                    }}
                />

            )
        } catch (error) {
            errorMessage(error.message)
        }
    }, [state])

    const renderAutoComplete = useCallback((label, stateKey, list = []) => {
        return (
            <Autocomplete
                size='small'
                options={list || []}
                getOptionLabel={(option) => option}
                value={state[stateKey]}
                onChange={(event, newValue) => { onChangeHandle(stateKey, newValue) }}
                renderInput={(params) => (
                    <TextField
                    required
                        {...params}
                        sx={{ width: "7dvw" }}
                        label={label}
                        placeholder={label}
                    />
                )}
            />)
    }, [state])

    const onClearHandler = useCallback(() => {
        setState((prevState) => ({
            ...prevState,
            selectedDate: new Date(),
            hours: "",
            minutes: "",
            meridian: "",
            glucose_value: "",
            instruction: "",
            isEditClked: false,
            editIndex: null,
            editData: {},
            selectedId: null,
            drugList: [],
             nurseName: null,
        }));

        setDrugFields([{ drug_name: "", drugList: [], unitType: "", unitValue: "" }]);
    }, []);


    const onChangeHandle = useCallback((stateKey, value) => {
        setState((prevState) => ({
            ...prevState,
            [stateKey]: value
        }));
    }, [state])

    // edit functions
const onEditHandler = useCallback((item, index) => {
    
    setState((prevState) => {
        const [hourStr, minStr] = item?.entered_time?.split(":") || [];
        let hour = parseInt(hourStr, 10);
        const minutes = minStr?.slice(0, 2) || "";
        let meridian = "AM";
        if (hour >= 12) {
            meridian = "PM";
            if (hour > 12) hour -= 12;
        }
        if (hour === 0) hour = 12;

        let selectedDate = null;
        if (item?.entered_date) {
            const [day, month, year] = item.entered_date.split("-");
            selectedDate = new Date(`${year}-${month}-${day}`);
        } 
        const foundNurse = prevState.NurseList.find(
            nurse => nurse.staff_id === item.nurse_profile_id
        );

        return {
            ...prevState,
            isEditClked: true,
            editIndex: index,
            editData: item,
            instruction: item?.instructions || "",
            glucose_value: Object.values(item.glucose_value || {})[0] || "",
            selectedDate: selectedDate,
            entered_time: item?.entered_time || "",
            hours: hour.toString(),
            minutes: minutes,
            meridian: meridian,
            selectedId: item?.id,
            nurseName:  foundNurse || null,
        };
    });
    setDrugFields(
        item?.drugs?.map(d => ({
            drug_name: d.drug_name,
            unitType: d.unit_type,
            unitValue: d.unit_value,
        })) || []
    );
}, []);


    const onCancelHandler = useCallback(() => {
        setState((prevState) => ({
            ...prevState,
            isEditClked: false,
            editIndex: null,
            editData: {},
        }));
    }, [state])

    // delete functions
    const onDeleteHandler = useCallback((item) => {
        setState((prevState) => ({
            ...prevState,
            deletePopup: true,
            selectedId: item?.id
        }));
    }, [state])

    const popupClose = useCallback(() => {
        setState((prevState) => ({
            ...prevState,
            deletePopup: false,
            selectedId: null,
            removeData: false,
        }));
    }, [state])

    const deleteGlucoseData = useCallback(() => {
        try {
            onChangeHandle("removeData", true);
            let url = `${Serviceurls.IP_DOC_GLUCOSE_GET}?id=${state.selectedId}`;
            if (props.is_From_IpNotes && state.clinic_id) {
                url = `${url}&clinic_id=${state.clinic_id}`
            }
            RestAPIService.delete(url)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        popupClose();
                        setState((prev) => {
                            const deletedItem = prev.glucoseData.find(
                                (item) => item.id === state.selectedId
                            );
                            const deletedDrugs = deletedItem?.drugs?.map(
                                (d) => d.drug_name
                            ) || [];

                            return {
                                ...prev,
                                // glucoseData: prev.glucoseData.filter(
                                //     (item) => item.id !== state.selectedId
                                // ),
                                // headerData: prev.headerData.filter(
                                //     (header) => !deletedDrugs.includes(header)
                                // ),
                                deletePopup: false,
                                selectedId: null,
                            };
                        });
                        const updatedDrugs = drugFields.filter((_, i) => i !== state?.index);
                        setDrugFields(updatedDrugs);

                        getGlucoseData()
                    }
                }).catch((error) => {
                    onChangeHandle("removeData", false);
                    errorMessage(error?.response?.data?.message || error.message);
                })
        } catch (error) {
            onChangeHandle("removeData", false);
            errorMessage(error.message)
        }
    }, [state])

    const renderButton = useCallback(
        (title, imgSrc, onClick, disabled = false) => (
            <Tooltip title={title} placement="top" arrow>
                <Button
                    disabled={disabled}
                    className="eMed_usrconf_btn"
                    onClick={onClick}
                    sx={{
                        opacity: disabled ? 0.5 : 1,
                        pointerEvents: disabled ? "none" : "auto",
                    }}
                >
                    <img
                        src={imgSrc}
                        alt={title}
                        style={{ width: "1.5vw", height: "1.5vw" }}
                    />
                </Button>
            </Tooltip>
        ),
        []
    );


    // render
    const { t } = props
    const attenderDetails = useMemo(() => ({
        lineOne: t("AttenderName"),
        lineTwo: `${state.attender_name ? state.attender_name : " -"}`,
        lineFour: t('ContactNumber'),
        LineFive: `${state.attender_mobile ? state.attender_mobile : "-"}`
    }), [state.attender_name, state.attender_mobile, t]);

    const doctorDetails = useMemo(() => ({
        lineOne: t("ConsultantName"),
        lineTwo: `${state.doctor_name ? state.doctor_name : " -"}`
    }), [state.doctor_name, t]);

    const isAvailable = useMemo(() => ((state.high_value !== '') || (state.low_value !== '') ? true : false)
        , [state.high_value, state.low_value]);

    const onDeleteDrug = (index) => {
        const updatedDrugs = drugFields.filter((_, i) => i !== index);
        setDrugFields(updatedDrugs);

    };
    const formatTime = (time24) => {
        if (!time24) return "-";
        const [hourStr, minStr] = time24.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = minStr;
        const meridian = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12; // Convert 0 -> 12 for AM
        return `${hour.toString().padStart(2, "0")}:${minute} ${meridian}`;
    };
 


    return (

        <Box component={'div'} className='eMed_medication_Container' sx={{ backgroundColor: Colors.configHomeBg }}>
            <Box display={'flex'} >
                <Box className='eMed_nur_notes_details eMed_patient_nur_notes'>
                    <CommonPatientDetails data={state.patientData} showDetailed={true} />
                </Box>
                <CommonPatientCard details={attenderDetails} showDetailed={true} />
                <ConsultantPatientCard name={doctorDetails} width={props.is_From_IpNotes ? "20dvw" : null} />
            </Box>
            {/* header start*/}
            <Box component={'div'} className='eMed_medication_mainDiv' sx={{ margin: "0.5dvw", }}>
               
                
                <Paper
                    sx={{
                        padding: "0.625dvw",
                        marginBottom: "0.5dvw",
                        height: "auto",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Typography
                        fontSize={"0.9vw"}
                        padding={"0.2dvw"}
                        fontWeight={"bold"}
                        color={"gray"}
                        borderBottom={"0.5px solid gray"}
                        marginBottom={"0.5vw"}
                    >
                        Add Glucose Log
                    </Typography>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        gap="0.625dvw"
                        margin="0.5dvw"
                        sx={{ width: "100%" }}
                    >
                        {/* Date & Time */}
                        {renderDatePicker()}
                        <Box display="flex" flexWrap="wrap" gap="0.625dvw">
                            {renderAutoComplete("Hour", "hours", hourList)}
                            {renderAutoComplete("Minute", "minutes", minuteList)}
                            {renderAutoComplete("AM/PM", "meridian", meridianList)}
                        </Box>

                        {/* Glucose Value */}
                        {renderTextBox("Value", "glucose_value")}

                        {/* Dynamic Drug Fields */}
                        {drugFields.map((field, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "0.625dvw",
                                    alignItems: "center",
                                }}
                            >
                                {/* Drug Search */}
                                <Autocomplete
                                    size="small"
                                    freeSolo
                                    loading={isLoading}
                                    loadingText="Loading drugs..."
                                    sx={{
                                        width: "200px",
                                        flex: "1 1 auto",
                                    }}
                                    options={state.drugList || []}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.displayTxt
                                    }
                                    value={field.drug_name || ""}
                                    onChange={(e, value) => {
                                        const updated = [...drugFields];
                                        updated[index].drug_name = value?.displayTxt || "";
                                        setDrugFields(updated);
                                        setState(prev => ({
                                            ...prev,
                                            drugList: []
                                        }))
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            {...params}
                                            label="Select Drug"
                                            placeholder="Search drug"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {isLoading[index] ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const updated = [...drugFields];
                                                updated[index].drug_name = value || "";
                                                setDrugFields(updated);
                                                if (value.trim()) {
                                                    getDrugSuggestionApi.current(value, index);
                                                }
                                            }}
                                        />
                                    )}
                                />

                                {/* Unit Type */}
                                <Autocomplete
                                    options={Array.from({ length: 50 }, (_, i) => i + 1)} // creates [1, 2, 3, ..., 50]
                                    value={field.unitValue || null}
                                    onChange={(e, newValue) => {
                                        const updated = [...drugFields];
                                        updated[index].unitValue = newValue;
                                        setDrugFields(updated);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Unit Value"
                                            size="small"
                                            variant="outlined"
                                        />
                                    )}
                                    sx={{
                                        minWidth: "130px",
                                        maxWidth: "200px",
                                        flex: "1 1 auto",
                                    }}
                                />

                                <FormControl required sx={{
                                    minWidth: "130px",
                                    maxWidth: "200px",
                                    flex: "1 1 auto",
                                }} size="small">
                                    <InputLabel>Unit Type</InputLabel>
                                    <Select
                                        value={field.unitType || ""}
                                        label="Unit Type"
                                        onChange={(e) => {
                                            const updated = [...drugFields];
                                            updated[index].unitType = e.target.value;
                                            setDrugFields(updated);
                                        }}
                                        MenuProps={{ style: { maxHeight: 350 } }}
                                    >
                                        {filterUnit?.length > 0 ? (
                                            filterUnit.map((list, idx) => (
                                                <MenuItem key={idx} value={list.unit}>
                                                    {list.unit}
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem disabled>No data</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>

                                {drugFields?.length > 1 && index !== 0 && renderButton(
                                    "Delete",
                                    ImagePaths.Delete.default,
                                    () => onDeleteDrug(index)
                                )}
                            </Box>
                        ))}

                        <Button
                            variant="contained"
                            size="small"
                            className="eMed_nur_btn_two"
                            onClick={plusHandle}
                            disabled={
                                drugFields?.length > 2 ||

                                !state?.hours ||
                                !state?.minutes ||
                                !state?.meridian ||
                                !state?.glucose_value ||

                                drugFields.some(
                                    (field) => !field.drug_name || !field.unitType || !field.unitValue
                                )
                            }
                        >
                            <AddIcon />
                        </Button>

                        {/* Instruction and Nurse Name in a row */}
                        <Box
                            display="flex"
                            flexWrap="wrap"
                            gap="0.625dvw"
                            sx={{
                                width: "100%",
                                alignItems: "center"
                            }}
                        >
                            <TextField
                                label="Instruction"
                                size="small"
                                variant="outlined"
                                sx={{
                                    minWidth: "120px",
                                    maxWidth: "200px",
                                    flex: "1 1 auto",
                                }}
                                value={state.instruction}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const filtered = value.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, 250);
                                    setState((prev) => ({ ...prev, instruction: filtered }));
                                }}
                            />

                                <Autocomplete
                                    size='small'
                                    options={state.NurseList || []}
                                    getOptionLabel={(option) => option.nurse}
                                    value={state.nurseName}
                                    onChange={(event, newValue) => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            nurseName: newValue
                                        }))
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{
                                                minWidth: "120px",
                                                maxWidth: "300px",
                                                width: "15dvw",
                                                flex: "1 1 auto",
                                            }}
                                            {...params}
                                            label={t("Nurse Name *")}
                                        />
                                    )}
                                />
                        </Box>

                        {/* Buttons */}
                        <Box display="flex" justifyContent={"end"} gap="0.625dvw" flex="1 1 100%" mt={1}>
                            <Button
                                variant="outlined"
                                size="small"
                                className="eMed_nur_btn_two"
                                disabled={state.withOutAppointment?.is_ip}
                                onClick={onClearHandler}
                            >
                                {t("Clear")}
                            </Button>
                            {
                                !state.isEditClked ? (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        className="eMed_nur_btn_two"
                                        sx={{ mr: 3 }}
                                        disabled={
                                            disableBtn ||
                                            !(
                                                state.glucose_value &&
                                                // state.nurseName &&
                                                state.hours &&
                                                state.minutes &&
                                                state.meridian &&
                                                drugFields.every(
                                                    (field) => field.unitType && field.drug_name && field.unitValue
                                                )
                                            )
                                        }
                                        onClick={postGlucoseLog}
                                    >
                                        {t("Add")}
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        className="eMed_nur_btn_two"
                                        sx={{ mr: 3 }}
                                        disabled={
                                            disableBtn ||
                                            !(
                                                state.glucose_value &&
                                                state.hours &&
                                                state.nurseName &&
                                                state.minutes &&
                                                state.meridian &&
                                                drugFields.every(
                                                    (field) => field.unitType && field.drug_name && field.unitValue
                                                )
                                            )
                                        }
                                        onClick={updateGlucoseData}
                                    >
                                        Update
                                    </Button>
                                )
                            }
                        </Box>
                    </Box>
                </Paper>

                {/* table start */}
                <Paper
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "37vh", 
                        paddingBottom: 1,
                    }}
                >
                    <Box
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="0.3vw 0.625dvw"
                    >
                        <Typography fontSize="0.95vw" fontWeight="bold" color="gray">
                            Glucose Log
                        </Typography>
                        <Box display="flex" alignItems="center" gap="0.625vw">
                            {renderTextBox("High", "high_value", "8vw")}
                            {renderTextBox("Low", "low_value", "8vw")}
                        </Box>
                    </Box>

                    {/* Scrollable Table Section */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "auto",
                            width: "100%",
                        }}
                    >
                        <Table stickyHeader size="small" sx={{ tableLayout: "fixed", minWidth: "max-content" }}>
                            <TableHead>
                                <TableRow>
                                    {/* Sticky: Date & Time */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "12vw",
                                            position: "sticky",
                                            left: 0,
                                            top: 0,
                                            zIndex: 5,
                                            backgroundColor: "#faf9f9",
                                            borderRight: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Typography fontWeight={600} fontSize="0.9vw">
                                            Date & Time
                                        </Typography>
                                    </TableCell>


                                    {/* Sticky: Glucose Value */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "8vw",
                                            position: "sticky",
                                            left: "12vw",
                                            top: 0,
                                            zIndex: 5,
                                            backgroundColor: "#faf9f9",
                                            borderRight: "2px solid #e0e0e0",
                                        }}
                                    >
                                        <Typography fontWeight={600} fontSize="0.9vw">
                                            Glucose Value
                                        </Typography>
                                    </TableCell>

                                    {/* Dynamic Drug Headers */}
                                    {/* <Tooltip title={state.headerData?.length > 3 ? "View added Drug list" : ""} placement="top" arrow > */}
                                    {state.headerData?.length > 0 ? (

                                        state.headerData.map((header, i) => (

                                            <TableCell
                                                key={i}
                                                align="center"
                                                sx={{
                                                    minWidth: "10vw",
                                                    backgroundColor: "#faf9f9",
                                                    borderRight: "1px solid #e0e0e0",
                                                }}
                                            >
                                                <Typography fontWeight={600} fontSize="0.9vw">{header}</Typography>
                                            </TableCell>


                                        ))
                                    ) : (
                                        <TableCell align="center" sx={{ minWidth: "10vw", backgroundColor: "#faf9f9", borderRight: "1px solid #e0e0e0" }}>
                                            <Typography fontWeight={600} fontSize="0.9vw">Drugs</Typography>
                                        </TableCell>
                                    )}


                                    {/* {UserData?.module_name !== "nurse" && ( */}
                                        <TableCell
                                            align="center"
                                            sx={{
                                                width: "12vw",
                                                position: "sticky",
                                                right: "22vw",
                                                top: 0,
                                                zIndex: 5,
                                                backgroundColor: "#faf9f9",
                                                borderLeft: "1px solid #e0e0e0",
                                                borderRight: "1px solid #e0e0e0",
                                            }}
                                        >
                                            <Typography fontWeight={600} fontSize="0.9vw">
                                                Nurse Name
                                            </Typography>
                                        </TableCell>
                                    {/* )} */}

                                    {/* Sticky: Instruction */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "12vw",
                                            position: "sticky",
                                            right: "10vw",
                                            top: 0,
                                            zIndex: 5,
                                            backgroundColor: "#faf9f9",
                                            borderLeft: "1px solid #e0e0e0",
                                            borderRight: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Typography fontWeight={600} fontSize="0.9vw">Instruction</Typography>
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "10vw",
                                            position: "sticky",
                                            right: 0,
                                            top: 0,
                                            zIndex: 6,
                                            backgroundColor: "#faf9f9",
                                            borderLeft: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Typography fontWeight={600} fontSize="0.9vw">Action</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {state.glucoseData?.length > 0 ? (
                                    state.glucoseData.map((item, idx) => (
                                        <TableRow key={idx}>
                                            {/* Sticky Date & Time */}

                                            <TableCell
                                                align="center"
                                                sx={{
                                                    width: "12vw",
                                                    position: "sticky",
                                                    left: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 4,
                                                    borderRight: "1px solid #e0e0e0",
                                                }}
                                            >

                                                {item.entered_date} | {formatTime(item.entered_time)}

                                            </TableCell>

                                            {/* Sticky Glucose Value */}
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    width: "8vw",
                                                    position: "sticky",
                                                    left: "12vw",
                                                    zIndex: 4,
                                                    borderRight: "2px solid #e0e0e0",
                                                    backgroundColor: (() => {
                                                        const glucose = Object.values(item.glucose_value || {})[0];
                                                        if (!glucose) return "#fff"; // No value

                                                        const high = parseFloat(state.high_value) || 0;
                                                        const low = parseFloat(state.low_value) || 0;
                                                        const g = parseFloat(glucose);

                                                        if (g > high && high > 0) return "#90caf9";     // High → light blue
                                                        if (g < low && low > 0) return "#bbdefb";        // Low → lighter blue
                                                        return "#fff";                                   // Normal → white
                                                    })(),
                                                }}
                                            >
                                                <Typography fontWeight={600} fontSize="0.85vw">
                                                    {Object.values(item.glucose_value || {})[0] || "-"}
                                                </Typography>
                                            </TableCell>



                                            {/* Dynamic Drug Data */}
                                            {state.headerData?.map((drugName, i) => {
                                                const drug = item.drugs?.find((d) => d.drug_name === drugName);
                                                return (
                                                    <TableCell
                                                        key={i}
                                                        align="center"
                                                        sx={{
                                                            minWidth: "10vw",
                                                            whiteSpace: "nowrap",
                                                            borderRight: "1px solid #e0e0e0",
                                                        }}
                                                    >
                                                        <Typography fontSize="0.85vw">
                                                            {drug ? `${drug.unit_value} ${drug.unit_type}` : "-"}
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            })}
                                            {/* Sticky Nurse Name */}
                                            {/* {UserData?.module_name !== "nurse" && ( */}
                                                <TableCell
                                                    align="center"
                                                    sx={{
                                                        width: "12vw",
                                                        position: "sticky",
                                                        right: "22vw",
                                                        backgroundColor: "#fff",
                                                        zIndex: 4,
                                                        borderRight: "1px solid #e0e0e0",
                                                        borderLeft: "2px solid #e0e0e0",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <Tooltip
                                                        title={item?.nurse_name || "-"}
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <Typography fontSize="0.85vw" noWrap>
                                                            {item?.nurse_name || "-"}
                                                        </Typography>
                                                    </Tooltip>
                                                </TableCell>
                                            {/* )} */}


                                            { }
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    width: "12vw",
                                                    position: "sticky",
                                                    right: "10vw",
                                                    backgroundColor: "#fff",
                                                    zIndex: 4,
                                                    borderRight: "1px solid #e0e0e0",
                                                    borderLeft: "2px solid #e0e0e0",
                                                    whiteSpace: "nowrap",
                                                }}

                                            >
                                                <Tooltip title={item?.instructions ? item?.instructions : "-"} placement="top" arrow >
                                                    <Typography fontSize="0.85vw" noWrap>
                                                        {item?.instructions ? item?.instructions : "-"}
                                                    </Typography>
                                                </Tooltip>



                                            </TableCell>

                                            {/* Sticky Actions */}
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    width: "10vw",
                                                    position: "sticky",
                                                    right: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 4,
                                                }}
                                            >

                                                {/* Old code */}
                                                {/* {
                                                    (state.isEditClked && state.editIndex === idx) ?
                                                        <Box display={"flex"} gap={"0.625dvw"} justifyContent={"center"} alignItems={"center"}>
                                                            {renderButton("Save", ImagePaths.TickEnable.default, updateGlucoseData, state.saveClked)}
                                                            {renderButton("Cancel", ImagePaths.RejectEnable.default, onCancelHandler)}
                                                        </Box> :
                                                        <Box display={"flex"} gap={"0.625dvw"} justifyContent={"center"} alignItems={"center"}>
                                                            {renderButton("Edit", ImagePaths.Edit.default, () => onEditHandler(item, idx))}
                                                            {renderButton("Delete", ImagePaths.Delete.default, () => onDeleteHandler(item), state.deletePopup)}
                                                        </Box>
                                                } */}
                                                <Box display="flex" gap="0.625dvw" justifyContent="center" alignItems="center">
                                                    {renderButton(
                                                        "Edit",
                                                        ImagePaths.Edit.default,
                                                        () => onEditHandler(item, idx),
                                                        ((state.isEditClked && state.editIndex === idx) || !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Glucose Log", "SubTab")?.editAccess)
                                                    )}
                                                    {renderButton(
                                                        "Delete",
                                                        ImagePaths.Delete.default,
                                                        () => onDeleteHandler(item),
                                                        ((state.isEditClked && state.editIndex === idx) || !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Glucose Log", "SubTab")?.editAccess)
                                                    )}
                                                </Box>

                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={state.headerData.length + 5} align="center" sx={{ py: 5 }}>
                                            No Records To Be Shown
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                    </Box>

                </Paper>
            </Box>
            <Loader loaderOpen={state.isLoader} />
            {state.deletePopup && <DeletePopup
                DeletTitle={`${t("deleteMsg")} ?`}
                deleteAlertPopupClose={popupClose.bind(this)}
                removeData={deleteGlucoseData.bind(this)}
                disable={state.removeData}
            />}
            {state.isErrorMsg && <ToastMsg
                severity={'error'}
                msg={state.isErrorMsgText}
                msgPop={msgClose.bind(this)}
            />}
            {state.successMsg && <ToastMsg
                severity={'success'}
                msg={state.successMsgText}
                msgPop={msgClose.bind(this)}
            />}
            {state.confirmPopup && (
                <Dialog
                    open={state.confirmPopup}
                    onClose={() => setState(prev => ({ ...prev, confirmPopup: false }))}
                >
                    <DialogTitle>Confirm Update</DialogTitle>
                    <DialogContent>
                        You have already entered a value for this time with a different value.
                        Do you want to update it too?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() =>
                                setState(prev => ({ ...prev, confirmPopup: false }))
                            }
                            color="error"
                            variant="outlined"
                            size="small"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                setState(prev => ({ ...prev, confirmPopup: false }));
                                createGlucoseLog();
                            }}
                            color="primary"
                            variant="contained"
                            size="small"
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

        </Box>
    )

}

export default withTranslation()(GlucoseLog)